/**
 * AWS Amplify Configuration
 * Configures Cognito authentication and API Gateway
 */

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_P2Fx5C7Dm',
      userPoolClientId: '3ga3ud2250d4gc8i3nhvt3dq0c',
      region: 'us-east-1',
      loginWith: {
        email: true,
        username: false
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true
        },
        given_name: {
          required: true
        },
        family_name: {
          required: true
        }
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true
      }
    }
  },
  API: {
    REST: {
      'access-control-api': {
        endpoint: 'https://35p69bdfu0.execute-api.us-east-1.amazonaws.com/production',
        region: 'us-east-1'
      }
    }
  }
}
